import { Link } from "react-router-dom";
import { ArrowLeft, Clock } from "@phosphor-icons/react";
import { ARTICLES } from "../../../data/articles/articlesData";
import MarkerStroke from "./MarkerStroke";
import useReveal from "./useReveal";
import "./home.css";
import "./HomeBlogPreview.css";

/*
 * Blog preview + SEO internal links to the top guides.
 * Keeps the same 6 featured slugs the old InternalLinks section surfaced,
 * so homepage link equity to the articles does not regress.
 */

const FEATURED_SLUGS = [
  "clinic-management-software-guide",
  "excel-to-clinic-management-system",
  "ai-therapy-summary-guide",
  "opening-private-clinic-guide",
  "reduce-no-shows-clinic-tips",
  "invoices-for-therapists-financial-guide",
];

const FEATURED = FEATURED_SLUGS.map((slug) => ARTICLES.find((a) => a.slug === slug)).filter(Boolean);

const CARDS = FEATURED.slice(0, 3);
const LINKS = FEATURED.slice(3);

function HomeBlogPreview() {
  const ref = useReveal();

  return (
    <section className="home-section home-section--white hblog" aria-labelledby="hblog-title">
      <div className="home-container">
        <div className="hblog-head">
          <div className="home-head">
            <h2 id="hblog-title" className="home-h2 home-h2--display">
              <span className="home-mark">
                מדריכים
                <MarkerStroke />
              </span>{" "}
              למטפלים שמנהלים קליניקה
            </h2>
          </div>
          <Link to="/blog" className="home-link hblog-all">
            לכל המאמרים
            <ArrowLeft size={16} weight="bold" />
          </Link>
        </div>

        <div className="hblog-grid home-reveal" ref={ref}>
          {CARDS.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} className="hblog-card home-card home-card--interactive home-bubble">
              <span className="hblog-card-meta">
                <Clock size={13} weight="bold" />
                {a.readTime} דק׳ קריאה
              </span>
              <h3 className="hblog-card-title">{a.title}</h3>
              <p className="hblog-card-desc">{a.description}</p>
              <span className="hblog-card-more">
                לקריאה
                <ArrowLeft size={14} weight="bold" />
              </span>
            </Link>
          ))}
        </div>

        <div className="hblog-links">
          {LINKS.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} className="hblog-link">
              {a.title}
              <ArrowLeft size={14} weight="bold" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeBlogPreview;
